import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from 'apps/wsg/src/app/angular-material.module';
import { FilterComponent } from './filter.component';
import { ConnectedDialogModule } from '@morningstar/shared/ui-kit/connected-dialog';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FilterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ConnectedDialogModule,
    AngularMaterialModule
  ],
  exports: [
    FilterComponent
  ]
})
export class FilterModule { }
